/**
 * Bot ilk kurulumda "otomatik görev işleme açık" bilgisinin TEK SEFERLİK kararı.
 *
 * DEV-3346-B22: kayıt yokken `GorevYoneticisi.initAutoPlay` sessizce AÇIK
 * tohumluyor (bkz. GorevYoneticisi.ts) ve bu açılış hiçbir yerde
 * duyurulmuyordu — yalnız KAPATMA onaylıydı (`otomatikGorevIslemeUyarisi.ts`).
 * Kullanıcı UYAP oturumu kurulur kurulmaz ücretli sorguların kendiliğinden
 * koşabileceğini bilmiyor olabilir.
 *
 * "İlk çalıştırma" testi tohum YAZILMADAN ÖNCEKİ anahtar yokluğuna bakar:
 * tohum bu anahtarı yazdığı için ikinci açılışta anahtar zaten var olur ve
 * bilgi bir daha çıkmaz — ayrı bir "gösterildi" anahtarına gerek yok.
 *
 * Karar saf tutuldu ki bileşen mount etmeden test edilebilsin (repo deseni).
 * localStorage OKUMASI bu modülün DIŞINDA (App.vue) yapılır ve orada
 * try/catch'e alınır: bozuk/erişilemez ortamda bilgi göstermemek yeterlidir.
 */

/** Tek seferlik bilgi metni. Süre/kapatılabilirlik App.vue'daki toast çağrısında belirlenir. */
export const ILK_KURULUM_BILGI_METNI =
    "Otomatik görev işleme varsayılan olarak açık: UYAP bağlanınca kuyruktaki " +
    "görevler (gece senkronu dahil) kendiliğinden işlenir. Kapatmak için Ayarlar menüsü.";

export interface IlkKurulumBilgisiKarari {
    /** true ise tek seferlik bilgi gösterilir. */
    goster: boolean;
    /** `goster` true iken kullanıcıya gösterilecek metin; aksi halde boş dize. */
    mesaj: string;
}

/**
 * kod inceleme: `autoPlayTohumu` parametresi kaldırıldı — bu dosyanın TEK
 * üretim çağrısı (App.vue) `initAutoPlay` tohumu için her zaman `true`
 * geçiyordu, `false` dalı yalnız testte tetikleniyordu. Bu dosya src/utils
 * altında, icrapro-app ile paylaşılan bir kod değil (ayrı repo).
 *
 * @param anahtarVarMiOncesi `initAutoPlay` commit'inden ÖNCE localStorage'da
 *   OTOMATIK_GOREV_ISLEME_ANAHTARI kaydının bulunup bulunmadığı.
 */
export function ilkKurulumBilgisiKarari(anahtarVarMiOncesi: boolean): IlkKurulumBilgisiKarari {
    const goster = anahtarVarMiOncesi !== true;
    return {
        goster,
        mesaj: goster ? ILK_KURULUM_BILGI_METNI : ""
    };
}
